/**
 * Resuelve URLs de imágenes servidas por el backend.
 *
 * Contexto: el backend guarda en BD rutas relativas tipo "/api/hero-slides/<id>/image/desktop"
 * o "/api/uploads/images/<f>.jpg". En el entorno de desarrollo esto funciona porque el frontend
 * y el backend comparten dominio. En producción (beta.ascauto.com + api-beta.ascauto.com)
 * el navegador las resuelve contra el dominio del frontend y falla.
 *
 * Este helper garantiza que cualquier URL relativa al backend se resuelva correctamente.
 *
 * Uso:
 *   <img src={getImageUrl(slide.image_url)} ... />
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function getImageUrl(url) {
  if (!url) return "";
  // URLs absolutas (http://, https://, data:, blob:) pasan tal cual
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  // Rutas relativas que el backend sirve bajo /api
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  // Otras rutas absolutas desde raíz (ej. /uploads/...) también las servimos desde el backend
  if (url.startsWith("/")) return `${BACKEND}${url}`;
  return url;
}

export default getImageUrl;
